import styled from '@emotion/styled';
import { StyledButton } from '../../shared/components/Button';

export const StyledCTAButton = styled(StyledButton)(({ theme }) => ({
    width: '100%',
    maxWidth: '300px',
    marginLeft: 'auto',
    marginRight: 'auto',
    height: `${theme.metrics.medium}`,
    marginTop: '20px',
}));

export const StyledNowrap = styled.span(() => ({
    whiteSpace: 'nowrap',
}));

export const StyledForgotPasswordLink = styled.span(({ theme }) => ({
    marginBottom: '8px',
    color: theme.colors.black,
    fontSize: theme.fontSizes['xs'],
    cursor: 'pointer',
    textDecoration: 'underline',
}));

export const StyledOpaquePassword = styled.span(() => ({
    opacity: '20%',
    margin: '10px 0px 5px 0px',
}));
export const StyledDeleteAccountLink = styled.span(({ theme }) => ({
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: '8px',
    color: theme.colors.black,
    fontSize: theme.fontSizes['xs'],
}));

export const StyledLogout = styled.span(() => ({
    justifySelf: 'right',
    display: 'flex',
}));

export const StyledTable = styled.div(() => ({
    display: 'inline',
    tableLayout: 'auto',
    margin: '10px 0px 10px 0px',
}));
export const StyledTableRow = styled.div(() => ({
    display: 'table-row',
}));
export const StyledTableCell = styled.div(() => ({
    display: 'table-cell',
    verticalAlign: 'middle',
}));
export const StyledTableCellRightSpace = styled.div(() => ({
    display: 'table-cell',
    verticalAlign: 'middle',
    paddingRight: '30px',
}));

export const StyledBalanceContainer = styled.div(() => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
}));
